import { render, staticRenderFns } from "./FixedMenu.vue?vue&type=template&id=37421f1a&lang=html&"
import script from "./FixedMenu.vue?vue&type=script&lang=js&"
export * from "./FixedMenu.vue?vue&type=script&lang=js&"
import style0 from "./FixedMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports